<template>
    <v-container>
        <div class="information_content">
            <h3>Paramètres de l'augmentation</h3>
            <v-layout row wrap>
                <v-flex xs10>
                    <v-text-field v-model="name" :readonly="!editName" filled label="Nom de l'augmentation"
                                  :rules="[rules.required, rules.counterName]" counter maxlength="50" />
                </v-flex>
                <v-flex v-if="!editName" xs1 />
                <v-flex v-if="!editName" xs1>
                    <v-btn class="custom_btn_position custom_btn_color_blue custom_btn_edit_url custom_btn_size"
                           @click="startEditName">
                        <i class="fas fa-pen" />
                    </v-btn>
                </v-flex>
                <v-flex v-if="editName" xs1>
                    <v-btn
                        class="custom_btn_position custom_btn_size custom_btn_color_red custom_btn_edit_url custom_btn_size"
                        @click="cancelEditName">
                        <i class="fas fa-times fa-btn" />
                    </v-btn>
                </v-flex>
                <v-flex v-if="editName" xs1>
                    <v-btn
                        class="custom_btn_position custom_btn_size custom_btn_color_blue custom_btn_edit_url custom_btn_size"
                        @click="updateEditName">
                        <i class="fas fa-check" />
                    </v-btn>
                </v-flex>
            </v-layout>
            <h3>Images augmentées</h3>
            <v-layout>
                <div class="images">
                    <p>Appuyez ci-dessous pour charger vos images à augmenter</p>
                    <p>
                        <strong
                            :class="{'overflow_quotas' : currentImagesQuota > maxImages || currentImagesQuota === maxImages}">
                            Nombre d'image maximum : {{ currentImagesQuota }} / {{ maxImages }}</strong>
                    </p>
                    <image-uploader :images="images" mode="augment" @updateImages="updateImages" />
                </div>
            </v-layout>
        </div>
    </v-container>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'ActionsTabParameters',
        components: {
            ImageUploader: () => import('../global/image_uploader')
        },
        data: () => ({
            editName: false,
            rules: {
                required: value => !!value || 'Required.',
                counterName: value => (value.length <= 50) || 'Max 50 characters'
            }
        }),
        computed: {
            ...mapGetters('app', ['currentImagesQuota', 'maxImages']),
            name: {
                get () {
                    return this.$store.state.actions.newAugmentationName;
                },
                set (name) {
                    this.$store.commit('actions/SET_AUGMENTATION_NAME', name);
                }
            },
            images: {
                get () {
                    return this.$store.state.actions.augmentation.images;
                }
            }
        },
        methods: {
            ...mapActions('actions', ['updateAugmentationName', 'updateAugmentationImages']),
            ...mapActions('app', ['refreshQuotas']),
            cancelEditName: function () {
                let name = this.$store.state.actions.augmentation.name;
                this.editName = !this.editName;
                this.$store.commit('actions/SET_AUGMENTATION_NAME', name);
            },
            updateEditName: function () {
                let data = {
                    experienceToken: this.$route.params.experienceToken,
                    augmentationToken: this.$route.params.augmentationToken
                };
                this.updateAugmentationName(data).then(() => {
                    this.editName = !this.editName;
                    this.$toasted.success('Nom de l\'augmentation mis à jour');
                }).catch((err) => {
                    this.cancelEditName();
                    this.$toasted.error(err);
                });
            },
            startEditName: function () {
                this.editName = !this.editName;
            },
            updateImages: function (event) {
                let data = {
                    experienceToken: this.$route.params.experienceToken,
                    augmentationToken: this.$route.params.augmentationToken,
                    images: event
                };
                this.updateAugmentationImages(data).then(() => {
                    this.refreshQuotas();
                }).catch((err) => {
                    this.$toasted.error(err);
                });
            }
        }
    };
</script>

<style scoped>
    .container {
        padding: 25px;
        max-width: 100% !important;
    }

    .information_content > h3 {
        margin-bottom: 20px;
    }

    .information_content > .layout {
        width: 100%;
        margin: 0;
    }

    .custom_btn_size {
        top: 28px;
        height: 50px !important;
        margin-left: 20px;
        width: calc(100% - 10px) !important;
        min-width: calc(100% - 10px) !important;
    }

    .custom_btn_size:last-of-type {
        margin: 0;
    }

    .custom_btn_position i {
        margin: 0;
    }

    .custom_btn_position {
        min-width: 48px;
    }

    .custom_btn_edit_url, .custom_btn_edit_url i {
        margin: 0 !important;
    }

    .images {
        left: 50%;
        position: relative;
        transform: translateX(-50%);
        width: 100%;
    }
</style>
